@if (workCenter) {
  <div class="layout-row gap-xxl">
    <!-- Packaging -->
    <div class="layout-col gap-md">
      <h4 class="text-title-medium">{{ 'context.general' | translate }}</h4>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'shopfloor.storage.defaultLocation' | translate }}</mat-label>
        <elder-select
          appStorageNodeSelect
          name="defaultStoragePath"
          placeholder="{{ 'shopfloor.storage.defaultLocation' | translate }}"
          required
          [facilityId]="workCenter.facility"
          valueAsId
          [value]="(defaultStorageLocation$ | async)?.id"
          (entityChange)="workCenter.packaging.defaultStoragePath = $event.path"
        >
        </elder-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'packaging.shape.strategy.title' | translate }}</mat-label>
        <elder-select
          appShapePackagingStrategySelect
          name="shapePackagingStrategy"
          required
          valueAsId
          [(ngModel)]="workCenter.packaging.shapePackaging.strategy"
        >
        </elder-select>
      </mat-form-field>

      @if (isPackageSharingEnabled()) {
        <h4 class="text-title-medium">{{ 'packaging.batchPackageSharing.title' | translate }}</h4>
        <mat-slide-toggle
          name="packageSharingScope"
          [checked]="isShared(workCenter)"
          (change)="updatePackageSharingScope($event)"
          [labelPosition]="'after'"
        >
          <div class="layout-row place-center-center">
            {{ 'context.enabled' | translate }}
          </div>
        </mat-slide-toggle>
      }
    </div>
    <!-- Bundle Specs / Limits -->
    <div class="layout-col gap-md">
      <!-- Package -->
      <h4 class="text-title-medium">{{ 'packages.packages' | translate }}</h4>
      <div class="layout-row place-start-center gap-md">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{ 'packaging.shape.title' | translate }}</mat-label>
          <elder-select
            appShapeSelect
            name="packageShape"
            required
            valueAsId
            [(ngModel)]="workCenter.packaging.shapePackaging.packageShape"
          >
          </elder-select>
        </mat-form-field>
        <mat-form-field style="width: 100px" subscriptSizing="dynamic">
          <mat-label>{{ 'packaging.shape.fillFactor' | translate }}</mat-label>
          <input
            matInput
            name="packageFillFactor"
            elderNoSpinner
            type="number"
            required
            min="0.1"
            max="10"
            pattern="^\d*[\.|,]?\d*$"
            placeholder="{{ 'packaging.shape.fillFactor' | translate }}"
            [(ngModel)]="workCenter.packaging.shapePackaging.packageFillFactor"
          />
        </mat-form-field>
      </div>
      <div class="layout-row place-start-center gap-md">
        <app-shape-size-constraint-input
          [namePrefix]="'pkg'"
          [strategy]="workCenter.packaging.shapePackaging.strategy"
          [shape]="workCenter.packaging.shapePackaging.packageShape"
          [sizeConstraint]="workCenter.packaging.shapePackaging.packageSizeConstraints"
        >
        </app-shape-size-constraint-input>
      </div>
      <div class="layout-row place-start-center gap-md">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{ 'packages.maxWeight' | translate }}</mat-label>
          <elder-quantity-input
            name="maxWeight"
            placeholder="{{ 'packages.maxWeight' | translate }}"
            [(ngModel)]="workCenter.packaging.maxWeight"
          >
          </elder-quantity-input>
          <mat-error elderValidationError></mat-error>
        </mat-form-field>
      </div>
      <!-- Positions-Gebinde -->
      <div class="layout-col gap-md">
        <h4 class="text-title-medium">{{ 'packages.item' | translate }}</h4>
        <div class="layout-row place-start-center gap-md">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>{{ 'packaging.shape.title' | translate }}</mat-label>
            <elder-select
              appShapeSelect
              name="bundleShape"
              required
              valueAsId
              [(ngModel)]="workCenter.packaging.shapePackaging.bundleShape"
            >
            </elder-select>
          </mat-form-field>
          <mat-form-field style="width: 100px" subscriptSizing="dynamic">
            <mat-label>{{ 'packaging.shape.fillFactor' | translate }}</mat-label>
            <input
              matInput
              name="bundleFillFactor"
              elderNoSpinner
              type="number"
              required
              min="0.1"
              max="10"
              pattern="^\d*[\.|,]?\d*$"
              placeholder="{{ 'packaging.shape.fillFactor' | translate }}"
              [(ngModel)]="workCenter.packaging.shapePackaging.bundleFillFactor"
            />
          </mat-form-field>
        </div>
        <app-shape-size-constraint-input
          [namePrefix]="'bundle'"
          [strategy]="workCenter.packaging.shapePackaging.strategy"
          [shape]="workCenter.packaging.shapePackaging.bundleShape"
          [sizeConstraint]="workCenter.packaging.shapePackaging.bundleSizeConstraints"
        >
        </app-shape-size-constraint-input>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{ 'packages.maxWeight' | translate }}</mat-label>
          <elder-quantity-input
            name="maxItemBundleWeight"
            placeholder="{{ 'packages.maxWeight' | translate }}"
            [(ngModel)]="workCenter.packaging.maxItemBundleWeight"
          >
          </elder-quantity-input>
          <mat-error elderValidationError></mat-error>
        </mat-form-field>
      </div>
      <!-- Position -->
      <div class="layout-col">
        <h4 class="text-title-medium">
          {{ 'positions.position' | translate }} ({{ 'context.pieces' | translate }})
        </h4>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{ 'packaging.shape.title' | translate }}</mat-label>
          <elder-select
            appShapeSelect
            name="unitShape"
            required
            valueAsId
            [(ngModel)]="workCenter.packaging.shapePackaging.unitShape"
          >
          </elder-select>
        </mat-form-field>
      </div>
    </div>
    <!-- Auto-Bundling -->
    <div class="layout-col gap-md">
      <h4 class="text-title-medium">{{ 'packages.calculation' | translate }}</h4>
      <mat-slide-toggle
        name="packageCalculationEnabled"
        [(ngModel)]="workCenter.packaging.packageCalculationEnabled"
        [labelPosition]="'after'"
      >
        <div class="layout-row place-center-center">
          {{ 'context.enabled' | translate }}
        </div>
      </mat-slide-toggle>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'packaging.approach.title' | translate }}</mat-label>
        <elder-select
          appPackagingStrategySelect
          name="packagingStrategy"
          required
          valueAsId
          [disabled]="!workCenter?.packaging?.packageCalculationEnabled"
          [(ngModel)]="workCenter.packaging.packagingStrategy"
        >
        </elder-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'packaging.distributionMode.title' | translate }}</mat-label>
        <elder-select
          appPackagingDistributionModeSelect
          name="distributionMode"
          required
          valueAsId
          [parentStrategy]="workCenter?.packaging?.packagingStrategy"
          [disabled]="!workCenter?.packaging?.packageCalculationEnabled"
          [(ngModel)]="workCenter.packaging.distributionMode"
        >
        </elder-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'packaging.itemPackageSharing.title' | translate }}</mat-label>
        <elder-select
          appItemPackageSharingSelect
          name="itemPackageSharing"
          required
          valueAsId
          [matTooltip]="
            'packaging.itemPackageSharing.tooltip.' + workCenter.packaging.itemPackageSharing
              | translate
          "
          [matTooltipDisabled]="!workCenter?.packaging?.packageCalculationEnabled"
          [disabled]="!workCenter?.packaging?.packageCalculationEnabled"
          [(ngModel)]="workCenter.packaging.itemPackageSharing"
        >
          <div
            *elderSelectValue="let value"
            [matTooltip]="'packaging.itemPackageSharing.tooltip.' + value.value | translate"
          >
            <span>{{ value.displayValue }}</span>
          </div>
        </elder-select>
      </mat-form-field>
    </div>
  </div>
}
